import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localeMetadata from '../i18n.locales.json';

// Import translation files
import enCommon from '../locales/en/common.json';
import deCommon from '../locales/de/common.json';
import frCommon from '../locales/fr/common.json';
import esCommon from '../locales/es/common.json';
import itCommon from '../locales/it/common.json';
import ptCommon from '../locales/pt/common.json';
import nlCommon from '../locales/nl/common.json';

const resources = {
  en: {
    common: enCommon,
  },
  de: {
    common: deCommon,
  },
  fr: {
    common: frCommon,
  },
  es: {
    common: esCommon,
  },
  it: {
    common: itCommon,
  },
  pt: {
    common: ptCommon,
  },
  nl: {
    common: nlCommon,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: localeMetadata.fallbackLocale,
  supportedLngs: localeMetadata.supportedLocales,
  debug: process.env.NODE_ENV === 'development',

  interpolation: {
    escapeValue: false,
  },

  // We'll let the Next.js router control the language
  // and sync it via the useTranslation hook
  lng: undefined, // Let the language detector do its work

  ns: ['common'],
  defaultNS: 'common',

  // Handle missing keys explicitly to avoid en-DE fallback
  missingKeyHandler: (lng, ns, key) => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(`Missing translation key: ${key} for language: ${lng}`);
    }
  },
});

export default i18n;
